<template>
  <div
    class="container"
    id="pageMockLogs"
    style="padding-top: 0px; max-width: 900px !important"
  >
    <v-container grid-list-xl fluid>
      <v-layout row wrap>
        <v-flex sm12>
          <h2>Meu histórico</h2>
        </v-flex>
      </v-layout>
      <div>
        <v-card :loading="loading" class="mx-auto text-center" flat>
          <v-toolbar
            color="lighten-4"
            :class="$vuetify.theme.isDark ? 'black' : 'grey'"
            flat
          >
            <v-spacer></v-spacer>
            <v-menu bottom left>
              <template v-slot:activator="{ on }">
                <v-btn v-on="on" icon>
                  <v-icon>more_vert</v-icon>
                </v-btn>
              </template>
              <v-list>
                <v-list-item @click="clearMockLogs">
                  <v-list-item-title>
                    <v-icon>delete</v-icon>
                    Limpar Histórico
                  </v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </v-toolbar>
          <v-card-text>
            <mock-result
              v-if="result && showResults"
              :hidden="true"
              :disabled="!showResults"
              :mockLogId="result.id"
              :totalQuestions="result.questions.data.length"
              :score="
                result.questions.data.filter(
                  (question) => question.correct === '1',
                ).length
              "
              reviewQuestions="true"
              hideReviewBtn="true"
              :review="result"
            ></mock-result>
            <template v-if="!loading">
              <template v-if="!mockLogs || mockLogs.length === 0">
                <p>Histórico Vazio</p>
              </template>
              <v-simple-table v-else>
                <template>
                  <thead>
                    <tr>
                      <th class="text-left">Data</th>
                      <th class="text-left">Tipo</th>
                      <th class="text-center">Status</th>
                      <th class="text-center">Score</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr :key="l.id" v-for="l in mockLogs">
                      <td class="text-left">{{ l.created_at }}</td>
                      <td class="text-left">
                        {{
                          l.mock_id !== null
                            ? "Simulado " + l.mock_title
                            : "Busca de questões"
                        }}
                      </td>
                      <td class="text-center" v-if="l.paused_at === null">
                        <v-chip
                          color="green"
                          text-color="white"
                          class="ml-2"
                          @click="getMockById(l.id)"
                        >
                          Finalizado
                        </v-chip>
                      </td>
                      <td class="text-center" v-else>
                        <v-chip color="secondary" text-color="white"
                          >Pausado</v-chip
                        >
                      </td>
                      <td
                        class="d-flex align-center justify-center"
                        v-if="l.paused_at === null"
                        @click="getMockById(l.id)"
                        :style="{ cursor: 'pointer' }"
                      >
                        <v-tooltip top>
                          <template v-slot:activator="{ on, attrs }">
                            <div v-bind="attrs" v-on="on">{{ l.score }}%</div>
                          </template>
                          <span>Revisar simulado</span>
                        </v-tooltip>
                      </td>
                      <td
                        v-else
                        class="d-flex align-center justify-center"
                        @click="continueMock(l.id)"
                      >
                        <v-tooltip top>
                          <template v-slot:activator="{ on }">
                            <div v-on="on">
                              <v-icon>play_circle_outline</v-icon>
                            </div>
                          </template>
                          <span>Continuar o simulado</span>
                        </v-tooltip>
                      </td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </template>
          </v-card-text>
        </v-card>
        <div v-if="!!mockLogs && mockLogs.length != 0" class="text-center">
          <v-pagination
            :length="meta.pagination.total_pages"
            @input="paginate"
            v-if="meta"
            v-model="meta.pagination.current_page"
          ></v-pagination>
        </div>
      </div>
    </v-container>
  </div>
</template>

<script>
import MockLogService from "../../services/mockLogs.service";
import MockService from "../../services/mocks.service";
import MockResult from "@/components/quiz/MockResult";

export default {
  components: { MockResult },
  metaInfo: {
    title: "LS",
    titleTemplate: "%s - Meu Histórico",
    htmlAttrs: {
      lang: "pt-br",
      amp: false,
    },
  },
  data() {
    return {
      loading: true,
      mockLogs: null,
      result: null,
      showResults: false,
      meta: null,
    };
  },
  created() {
    this.checkStorageForPausedOrCorrectingMocks().then(() => {
      this.loadLogs();
    });
  },
  methods: {
    loadLogs(page = 1) {
      this.loading = true;
      MockLogService.getListPublic({ page: page })
        .then((response) => {
          this.mockLogs = response.data;
          this.meta = response.meta;
          this.loading = false;
        })
        .catch((error) => {
          console.log("error", error);
          this.loading = false;
        });
    },
    checkStorageForPausedOrCorrectingMocks() {
      const promises = [];
      const keys = Object.keys(localStorage);
      keys.forEach((key) => {
        if (key.startsWith("mock_")) {
          const storedData = JSON.parse(localStorage.getItem(key));
          if (storedData) {
            const mockId = key.split("_")[1];
            if (storedData.status === "saindo") {
              localStorage.removeItem(key);
            } else if (storedData.status === "finalizando") {
              promises.push(
                MockService.checkAnswers(mockId, storedData.questions, true)
                  .then((response) => {
                    console.log("Correcting mock resumed:", response);
                    console.log("key:", key);
                    localStorage.removeItem(key);
                  })
                  .catch((error) => {
                    console.error("Error resuming correcting mock:", error);
                  }),
              );
            } else {
              promises.push(
                MockService.pauseMock(mockId, storedData.questions)
                  .then((response) => {
                    console.log("Paused mock resumed:", response);
                    console.log("key:", key);
                    localStorage.removeItem(key);
                  })
                  .catch((error) => {
                    console.error("Error resuming paused mock:", error);
                  }),
              );
            }
          }
        }
      });

      return Promise.all(promises)
        .then(() => {
          this.loading = false;
        })
        .catch((error) => {
          console.error("Error in processing mocks:", error);
          this.loading = false;
        });
    },

    paginate(e) {
      this.loadLogs(e);
    },
    continueMock(mockId) {
      this.$router.push({
        name: "mocks.start",
        params: { id: "continue" },
        query: { mockLogId: mockId },
      });
    },
    clearMockLogs() {
      this.loading = true;
      MockLogService.clearMockLogs()
        .then((response) => {
          console.log(response);
          this.mockLogs = null;
          this.meta = null;
          this.loading = false;
        })
        .catch((error) => {
          console.log("error", error);
          this.loading = false;
        });
    },
    getMockById(id) {
      this.$router.push({
        name: "mocks.start",
        params: { id: "review" },
        query: { mockLogId: id },
      });
      this.loading = true;
      this.showResults = false;
      MockLogService.getInfo(id)
        .then((response) => {
          this.result = response.data;
          this.showResults = true;
          this.loading = false;
        })
        .catch((error) => {
          console.log("error", error);
          this.loading = false;
        });
    },
  },
};
</script>
